module.exports = __webpack_public_path__ + "static/media/double_squared.1b82abf0.svg";